var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.825 13.775H14C14.2333 13.775 14.4292 13.6917 14.5875 13.525C14.7458 13.3583 14.825 13.1583 14.825 12.925V10.6L17 12.775V7.1L14.825 9.275V6.925C14.825 6.69167 14.7458 6.49583 14.5875 6.3375C14.4292 6.17917 14.2333 6.1 14 6.1H7.825C7.59167 6.1 7.39583 6.17917 7.2375 6.3375C7.07917 6.49583 7 6.69167 7 6.925V12.925C7 13.1583 7.07917 13.3583 7.2375 13.525C7.39583 13.6917 7.59167 13.775 7.825 13.775ZM2 22V3.5C2 3.11667 2.15 2.77083 2.45 2.4625C2.75 2.15417 3.1 2 3.5 2H20.5C20.8833 2 21.2292 2.15417 21.5375 2.4625C21.8458 2.77083 22 3.11667 22 3.5V16.5C22 16.8833 21.8458 17.2292 21.5375 17.5375C21.2292 17.8458 20.8833 18 20.5 18H6L2 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.9ec08e3e3a5f0a3f60c14d20ff78e840.svg";
export { ForwardRef as ReactComponent };